import dateformat from 'dateformat'
export const getContract=(BuyerInfo,SellerInfo,ContractTerm)=>{
  const row_0=new Array(9)
  const row_1=new Array(9)
  const row_2=new Array(9)
  const row_3=new Array(9)
  const row_4=new Array(9)
  const row_5=new Array(9)
  const row_6=new Array(9)
  const row_7=new Array(9)
  const row_8=new Array(9)
  const row_9=new Array(9)
  const sheetTitle=[ '序号','名称','规格描述','单位','数量','单价','合计','供货期','备注']
  const contract=new Array()

  for(let i=0;i<=8;i++){
    if(i==0){
      row_0[i]={
        v: '工业品购销合同',
      }
      row_1[i]={
        v: '买方',
      }
      row_2[i]={
        v: '卖方',
      }
      row_3[i]={
        v: '一、产品名称、描述、单位、数量、金额和供货期',
      }
      row_4[i]={
        v: '详见合同附件1-供货详单',
      }
      row_5[i]={
        v: '总计金额',
      }
      row_6[i]={
        v: ContractTerm.join('\n'),
      }
      row_7[i]={
        v: '买方',
      }
      row_8[i]={
        v: `单位名称: ${BuyerInfo.name||''}\n单位地址: ${BuyerInfo.registeredAdd||''}\n税号: ${BuyerInfo.businessLicenseNumber||''}\n法定代表人: ${BuyerInfo.LegalPerson||''}\n授权代理人: ${BuyerInfo.AuthorizedAgent||''}\n开户银行: ${BuyerInfo.bankName||''}\n银行帐号: ${BuyerInfo.accountNumber||''}\n电话: ${BuyerInfo.phone||''}\n传真: ${BuyerInfo.Fax||''}`,
      }
      row_9[i]={
        v: '合同附件1-供货详单',
      }
    }else if(i==2){
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: BuyerInfo.name||'',
      }
      row_2[i]={
        v: SellerInfo.fullname||'',
      }
      row_3[i]={
        v: '',
      }
      row_4[i]={
        v: '',
      }
      row_5[i]={
        v: '',
      }
      row_6[i]={
        v: '',
      }
      row_7[i]={
        v: '',
      }
      row_8[i]={
        v: '',
      }
      row_9[i]={
        v: '',
      }
    }else if(i==4){
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: '合同编号',
      }
      row_2[i]={
        v: '签定时间/地点',
      }
      row_3[i]={
        v: '',
      }
      row_4[i]={
        v: '',
      }
      row_5[i]={
        v: '',
      }
      row_6[i]={
        v: '',
      }
      row_7[i]={
        v: '卖方',
      }
      row_8[i]={
        v: `单位名称: ${SellerInfo.fullname||''}\n单位地址: ${SellerInfo.registeredAdd||''}\n税号: ${SellerInfo.businessLicenseNumber||''}\n法定代表人: ${SellerInfo.legalRepresentative||''}\n授权代理人: ${SellerInfo.AuthorizedAgent||''}\n开户银行: ${SellerInfo.bankName||''}\n银行帐号: ${SellerInfo.accountNumber||''}\n电话: ${SellerInfo.phone||''}\n传真: ${SellerInfo.Fax||''}`,
      }
      row_9[i]={
        v: '',
      }
    }else if(i==6){
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: "FT-"+ dateformat(new Date(), "yyyymmddHHMM"),
      }
      row_2[i]={
        v: dateformat(new Date(), "yyyy-mm-dd")+'/青岛',
      }
      row_3[i]={
        v: '',
      }
      row_4[i]={
        v: '',
      }
      row_5[i]={
        v: '',
      }
      row_6[i]={
        v: '',
      }
      row_7[i]={
        v: '',
      }
      row_8[i]={
        v: '',
      }
      row_9[i]={
        v: '',
      }
    }else{
      row_0[i]={
        v: '',
      }
      row_1[i]={
        v: '',
      }
      row_2[i]={
        v: '',
      }
      row_3[i]={
        v: '',
      }
      row_4[i]={
        v: '',
      }
      row_5[i]={
        v: '',
      }
      row_6[i]={
        v: '',
      }
      row_7[i]={
        v: '',
      }
      row_8[i]={
        v: '',
      }
      row_9[i]={
        v: '',
      }
    }
  }
  contract.unshift(sheetTitle)
  contract.unshift(row_9)
  contract.unshift(row_8)
  contract.unshift(row_7)
  contract.unshift(row_6)
  contract.unshift(row_5)
  contract.unshift(row_4)
  contract.unshift(sheetTitle)
  contract.unshift(row_3)
  contract.unshift(row_2)
  contract.unshift(row_1)
  contract.unshift(row_0)

  return contract
}
